import { CategorizationWithConfig } from "../../configMap/interfaces/category";
import useFixedCategorization from "./useFixedCategorization";
import useMetadataCategorization from "./useMetadataCategorization";

const useFixedMetadataCategorization = (
  categorizationWithConfig: CategorizationWithConfig,
  index: number,
  groupBlockId: string | undefined,
  disabled: boolean,
) => {
  const {
    tabId,
    selectedCategory,
    categorizationOptions,
    handleChange,
    handleFocus,
    handleBlur,
    handleSearch,
    handleFilter,
    status,
    isCategorizationDisabledByParent,
    disabledParentTooltip,
    isIncomplete,
    callEvents,
    isCategorizationLoading,
    emptySearchResult,
    loading,
    isLoadingValue,
  } = useFixedCategorization(categorizationWithConfig, index, groupBlockId);

  const { onFocus, className } = useMetadataCategorization(
    categorizationWithConfig,
    {
      handleFocus,
      handleSearch,
      isIncomplete,
      isCategorizationDisabledByParent,
    },
    disabled,
  );

  return {
    tabId,
    selectedCategory,
    categorizationOptions,
    handleChange,
    handleSearch,
    handleFilter,
    status,
    isCategorizationDisabledByParent,
    disabledParentTooltip,
    isIncomplete,
    callEvents,
    isCategorizationLoading,
    emptySearchResult,
    loading,
    isLoadingValue,
    onFocus,
    onBlur: handleBlur,
    className,
  };
};

export default useFixedMetadataCategorization;
